<template>
    <v-content>
        <v-breadcrumbs :items="breadCrumbs" large></v-breadcrumbs>
        <div class="form-company">
            <div class="tbl-btn" v-if="IsShowAccumulated">
                <v-btn @click="pupupModel" color="blue" dark>{{$t('accumulated')}} {{$t('report')}}  </v-btn>
            </div>
            <v-dialog v-model="popup.table"
                      transition="dialog-bottom-transition"
                      persistent
                      max-width="1000px"
                      fullscreen>
                <v-card>
                    <TableData @dialogueClose="dialogueClose"
                               v-if="popup.table"></TableData>
                </v-card>
            </v-dialog>


            <v-card class="pa-4" id="form_card" width="100%">
                <v-row>
                    <v-col cols="12" sm="6">
                        <div class="box-border">
                            <div class="employee-form-header">
                                <span>{{$t('company')}}</span>
                            </div>
                            <div>
                                <v-autocomplete :error-messages="companyIDErrors"
                                                :items="listDDLData.companyList"
                                                @change="getDdlData(logData.companyID,'company')"
                                                item-text="value"
                                                item-value="id"
                                              :label="$t('company')"
                                                required dense outlined
                                                chips
                                                multiple
                                                v-model="logData.companyID">
                                </v-autocomplete>
                            </div>

                            <div>
                                <v-autocomplete :items="listDDLData.departmentCompanyList"
                                                item-text="value"
                                                item-value="id"
                                                 :label="$t('department')"
                                                chips dense outlined
                                                clearable
                                                multiple
                                                v-model="logData.departmentID">
                                </v-autocomplete>
                            </div>
                        </div>
                    </v-col>

                    <v-col cols="12" sm="6">
                        <div class="box-border">
                            <div class="employee-form-header">
                                <span>{{$t('branch')}}</span>
                            </div>
                            <v-autocomplete :items="listDDLData.branchList"
                                            @change="getDdlData(logData.companyID,'branch')"
                                            item-text="value"
                                            item-value="id"
                                             :label="$t('branch')"
                                            chips dense outlined
                                            multiple
                                            clearable
                                            v-model="logData.branchID"></v-autocomplete>
                            <v-autocomplete :items="listDDLData.departmentBranchList"
                                            item-text="value"
                                            item-value="id"
                                            :label="$t('department')"
                                            chips dense outlined
                                            multiple
                                            clearable
                                            v-model="logData.departmentID">
                            </v-autocomplete>
                        </div>
                    </v-col>

                    <v-col cols="12" sm="6">
                        <div class="box-border">
                            <div class="employee-form-header">
                                <span>{{$t('depo')}}</span>
                            </div>
                            <v-autocomplete :items="listDDLData.depoList"
                                            @change="getDdlData(logData.companyID,'depo')"
                                            item-text="value"
                                            item-value="id"
                                           :label="$t('depo')"
                                            chips
                                            multiple dense outlined
                                            clearable
                                            v-model="logData.depoID">
                            </v-autocomplete>

                            <v-autocomplete :items="listDDLData.departmentDepoList"
                                            item-text="value"
                                            item-value="id"
                                             :label="$t('department')"
                                            chips
                                            multiple dense outlined
                                            clearable
                                            v-model="logData.departmentID">
                            </v-autocomplete>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <div v-if="searchReportType=='Other'" class="box-border">
                            <div class="employee-form-header">
                                <span>{{$t('type')}}</span>
                            </div>
                            <v-autocomplete :items="listDDLData.subSectionList"
                                            item-text="value"
                                            item-value="id"
                                            :label="$t('budget_sub_sections')"
                                            chips
                                            multiple dense outlined
                                            clearable
                                            v-model="logData.subSectionID">
                            </v-autocomplete>
                        </div>
                        <v-col>
                            <v-btn @click="search" class="ml-2" color="green" dark>
                                {{$t('search')}}
                            </v-btn>
                            <v-btn @click="reset" class="ml-2" color="blue darken-4" dark> {{$t('reset')}}</v-btn>
                        </v-col>
                    </v-col>
                </v-row>

            </v-card>
        </div>

        <div>
            <div class="tbl-btn">
                <v-btn @click="exportTableToExcel('tblData')" color="green" dark>{{$t('export')}}</v-btn>

            </div>
            <div id="tblData">
                <h2 style="text-align:center">आ.ब.{{showNextYear?YearPreviousCurrentNext.next:setYearValue}} को {{reportTitle}}</h2>
                <table class="table tbl sticky-table-header">
                    <thead v-if="groupLevel==1 || groupLevel==2">
                        <tr>
                            <th :rowspan="groupLevel">कार्यलय को नाम</th>
                            <template v-for="(header,index) in headers">
                                <th :colspan="header.listCount" style="text-align:center" v-bind:key="index+'headers'"
                                    v-if=" header.groupID > 0 ">
                                    <span v-if="header.showYear=='Next' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Current' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Previous' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                    </span>


                                    <!--NEW-->
                                    <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                    </span>
                                    <!--NEW END-->

                                    <span v-else> {{ header.groupName }}</span>

                                </th>
                                <template v-else>
                                    <template v-for="(column, subindex) in header.subList">
                                        <th rowspan="2" style="text-align:center" v-bind:key="index+'sub'+subindex">
                                            <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                            </span>

                                            <!--NEW-->
                                            <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                            </span>

                                            <!--END NEW-->
                                            <span v-else> {{ column.name }}</span>
                                        </th>
                                    </template>

                                </template>
                            </template>
                        </tr>
                        <tr>
                            <template v-for="(column, colsHeadersindex) in colsHeaders">
                                <th :key="colsHeadersindex+'colsHeadersindex'" style="text-align:center" v-if=" column.subTitleID>0 ">
                                    <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                    </span>
                                    <!--END NEW-->

                                    <span v-else> {{ column.name }}</span>
                                </th>
                            </template>
                        </tr>
                    </thead>
                    <thead v-if="groupLevel==3">
                        <tr>
                            <th rowspan="3">कार्यलय को नाम</th>
                            <template v-for="(header,headersindex) in headers">
                                <th :colspan="header.listCount" style="text-align:center" v-bind:key="headersindex+'headersindex'"
                                    v-if="header.groupID>0 ">
                                    <span v-if="header.showYear=='Next' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Current' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Previous' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                    </span>

                                    <!--END NEW-->

                                    <span v-else> {{ header.groupName }}</span>
                                </th>
                                <template v-else>
                                    <template v-for="(column, headerIndex) in header.list">
                                        <th :colspan="column.subList.length" rowspan="2" style="text-align:center"
                                            v-bind:key="headersindex+'headerIndex'+headerIndex" v-if="header.groupID>0">
                                            <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                            </span>

                                            <!--NEW-->
                                            <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                            </span>
                                            <!--END NEW-->

                                            <span v-else> {{ column.name }}</span>
                                        </th>
                                        <template v-else v-for="(subColumn, subListindex) in column.subList">
                                            <th rowspan="3" style="text-align:center" v-bind:key="headersindex+'headerIndex'+headerIndex+'subListindex'+subListindex">
                                                <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                                </span>
                                                <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                                </span>
                                                <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                                </span>

                                                <!--NEW-->
                                                <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                                </span>
                                                <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                                </span>
                                                <!--END NEW-->
                                                <span v-else> {{ subColumn.name }}</span>
                                            </th>
                                        </template>
                                    </template>

                                </template>
                            </template>
                        </tr>
                        <tr>
                            <template v-for="(column, subColumnsindex) in subColumns">
                                <th :colspan="column.subList.length" :key="subColumnsindex+'subColumnsindex'" style="text-align:center"
                                    v-if="column.groupID>0 ">
                                    <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.groupName }}
                                    </span>
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.groupName }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.groupName }}
                                    </span>
                                    <!--NEW-->
                                    <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.groupName }}
                                    </span>
                                    <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.groupName }}
                                    </span>
                                    <!--END NEW-->
                                    <span v-else> {{ column.groupName }}</span>
                                </th>
                                <template v-for="(subColumn, sub1index) in column.subList">
                                    <th :key="index+'sublist'+sub1index" rowspan="2" style="text-align:center"
                                        v-if="subColumn.titleID>0 && column.groupID==null">
                                        <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                        </span>
                                        <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                        </span>
                                        <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                        </span>
                                        <!--NEW-->
                                        <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                        </span>
                                        <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                        </span>
                                        <!--END NEW-->

                                        <span v-else> {{ subColumn.name }}</span>
                                    </th>
                                </template>
                            </template>
                        </tr>
                        <tr>
                            <template v-for="(column,index) in colsHeaders">
                                <th :key="index" style="text-align:center" v-if="column.subTitleID>0 ">
                                    <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                    </span>
                                    <!--NEW-->

                                    <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                    </span>
                                    <!--END NEW-->

                                    <span v-else> {{ column.name }}</span>
                                </th>
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(titleRows,index) in rows">
                            <tr :key="index" v-if="reportType=='Employee'">
                                <td :rowspan="titleRows.total+titleRows.list.length+titleRows.list.length">
                                    {{index+1}}.
                                    {{titleRows.company}}
                                </td>
                            </tr>
                            <tr :key="index" v-else>
                                <td :rowspan="titleRows.total+titleRows.list.length+titleRows.list.length+2">
                                    {{index+1}}.
                                    {{titleRows.company}}
                                </td>
                            </tr>
                            <template v-for="(section,sectionIndex) in titleRows.list">
                                <tr :key="index+'section'+sectionIndex" v-if="section.reportSectionID>0">
                                    <td :colspan="colsHeaders.length" style="background-color:#cdcdee;text-align:center">
                                        <span>{{section.reportSection}}</span>
                                    </td>
                                </tr>
                                <template v-for="(subSection,subSectionIndex) in section.list">
                                    <tr :key="index+'i'+sectionIndex+'subSection'+subSectionIndex">
                                        <td style="text-align:center">{{subSection.reportSubSection}}</td>
                                        <td :key="index+'col'+sectionIndex+'subSection'+subSectionIndex+'ssb'+subsectionsubIndex" style="text-align:center"
                                            v-for="(rowsHeader, subsectionsubIndex) in subSection.list">
                                            <span v-if="rowsHeader.dataType==2 || rowsHeader.dataType==4 || rowsHeader.dataType==6 || rowsHeader.dataType==5">
                                                {{rowsHeader.amount | filterZero}}
                                            </span>
                                            <span v-else>{{rowsHeader.value | filterZero}}</span>
                                        </td>
                                    </tr>
                                </template>
                                <tr :key="index+'section'+sectionIndex+'2ndRow'" v-if="reportType!='Employee'">
                                    <td style="text-align:center"><b>{{section.reportSection}}  जम्मा</b></td>
                                    <td :key="index+'section'+sectionIndex+'2ndRow'+subTotalInd" v-for="(total,subTotalInd) in section.totalSub" style="text-align:center">
                                        <b v-if="total.total!=null">{{total.total | filterZero}}</b>
                                    </td>
                                </tr>
                            </template>
                            <tr :key="index+'3rdrow'">
                                <td style="text-align:center"><b> जम्मा</b></td>
                                <td :key="index+'3rdrow'+totalsubIndex" v-for="(total,totalsubIndex) in titleRows.totalSub" style="text-align:center">
                                    <b v-if="total.total!=null">{{total.total | filterZero}}</b>
                                </td>
                            </tr>
                        </template>
                    </tbody>

                    <tfoot>
                        <tr class="tfoot">
                            <td colspan="2"><b> कुल जम्मा </b></td>
                            <td :key="totalIndex+'footer'" v-for="(total,totalIndex) in totals" style="text-align:center">
                                <b v-if="total.total!=null">{{total.total | filterZero}}</b>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            


        </div>
    </v-content>
</template>

<script>
    import {required} from "vuelidate/lib/validators";
    import axios from "axios";
    import TableData from "./table";

    export default {
        name: 'ReportComponent',
        // watch: {
        //     "logData.companyID": {
        //         handler: async function (val) {
        //             if (val) {
        //                 this.status.isCompany = true
        //                 this.status.isDepartment = true
        //                 this.error = true;
        //                 this.listDDLData.departmentList = [];
        //                 this.logData.branch = [];
        //                 axios.post("Department/DDLDepartmentList", {CompanyIDs: this.logData.companyID}).then(response => {
        //                     this.listDDLData.departmentList = response.data;
        //                 });
        //             }
        //         },
        //         deep: true
        //     },
        // },
        computed: {
            isCompany() {
                let check = this.role == "SuperAdmin"
                return check
            },
            isDepartment() {
                let check = this.role == "Company" || this.role == "SuperAdmin"
                return check
            },
            isBranch() {
                let check = this.role == "Company" || this.role == "SuperAdmin" || this.tokenData.role == "Department"
                return check
            },
            companyIDErrors() {
                const errors = [];
                if (!this.$v.logData.companyID.$dirty) return errors;
                !this.$v.logData.companyID.required &&
                errors.push("Company is required.");
                return errors;
            },
            yearErrors() {
                const errors = [];
                if (!this.$v.logData.year.$dirty) return errors;
                !this.$v.logData.year.required &&
                errors.push("Year is required.");
                return errors;
            },
            breadCrumbs() {
                return [
                    {
                        text: this.$t('dashboard'),
                        disabled: false,
                        to: `${this.userData.dashBoard}`,
                        exact: true
                    },
                    //{
                    //    text: 'Report Dashboard',
                    //    disabled: false,
                    //    to: "/reportDashboard",
                    //    exact: true

                    //},
                    {
                        text: this.$t('anusuchara_Report'),
                        disabled: false,
                        to: "/finalAnusucharu",
                        exact: true
                    },
                    {
                        text: this.$t('report'),
                        disabled: true,
                        exact: true
                    }

                ]
            }
        },
        filters: {
            filterZero: function (value) {
                if (value!==0) {
                    return value
                }
                else{
                    return ''
                }

            }
        },
        props: ['ApiData'],
        components: {
            TableData
        },
        data() {
            return {
                popup: {
                    table: false
                },
                
                selectedStatus: {
                    company: "",
                    branch: ""
                },

                error: false,
                callbackResponse: {
                    timeout: 6000,
                    message: ""
                },
                listDDLData: {
                    companyList: [],
                    departmentList: [],
                    branchList: [],
                    depoList: [],
                    subSectionList: [],
                    departmentBranchList: [],
                    departmentDepoList: [],
                    departmentCompanyList: []
                },
                status: {
                    isCompany: false,
                    isDepartment: false,
                },
                snackbar: false,
                panel: [0],
                table: false,
                dialogCreate: false,
                IsActive: false,
                TotalHeaderIndex: 0,
                rows: [],
                reportID: 0,
                reportTitle: "",
                totalRows: [],
                headers: [],
                colsHeaders: [],
                groupLevel: 0,
                totals: [],
                reportList: [],
                reportLogs: [],
                subColumns: [],
                yearList: [],
                tableFormData: [],
                logData: {
                    companyID: [],
                    departmentID: null,
                    branchID: null,
                    depoID: null,
                    subSectionID: null,
                    reportID: parseInt(this.$route.params.id),
                    year: "",
                    reportLogID: 0
                },
                serverData: {
                    companyID: "",
                    departmentID: "",
                    branchID: "",
                    depoID: "",
                    reportID: parseInt(this.$route.params.id),
                    year: "",
                    reportLogID: 0
                },
                role: this.$store.getters.getUserRole,
                userData: this.$store.getters.getUserData,
                yearShow: "",
                valueShow: "",
                setYearValue: "",
                setAllValue: "",
                submitStatus: "",
                YearPreviousCurrentNext: {},
                groupedRows: [],
                reportType: "",
                companyIDsFromServer: [],
                searchReportType: "",
                IsShowAccumulated: false,
                showNextYear: false,
            };
        },
        validations: {
            logData: {
                companyID: {required},
                year: {required},
            }
        },
        mounted() {

            this.loadCrumb()
            axios.get("ReportSettings/GetReportYearList").then(response => {
                this.yearList = response.data
            })
            this.getColsRow()

        },

        methods: {

            exportTableToExcel(tableID, filename = '') {
                var downloadLink;
                var dataType = 'application/vnd.ms-excel';
                var tableSelect = document.getElementById(tableID);
                var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

                // Specify file name
                filename = filename ? filename + '.xls' : 'excel_data.xls';

                // Create download link element
                downloadLink = document.createElement("a");

                document.body.appendChild(downloadLink);

                if (navigator.msSaveOrOpenBlob) {
                    var blob = new Blob(['\ufeff', tableHTML], {
                        type: dataType
                    });
                    navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // Create a link to the file
                    downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

                    // Setting the file name
                    downloadLink.download = filename;

                    //triggering the function
                    downloadLink.click();
                }
            },
            dialogueClose() {
                this.popup.table = false
            },

            pupupModel() {
                this.popup.table = true
            },
            getYearList(year) {
                if (this.yearList.length > 0) {
                    const currentYearIndex = this.indexWhere(this.yearList, item => item.value === year);
                    let previousThreeYearIndex = currentYearIndex - 3;
                    let previousTwoYearIndex = currentYearIndex - 2;
                    let previousYearIndex = currentYearIndex - 1;
                    let nextYearIndex = currentYearIndex + 1;
                    let previousCurrentNext = {};
                    this.yearList.forEach(function (data, yearIndex) {
                        if (currentYearIndex == yearIndex) {
                            previousCurrentNext.current = data.id
                        }
                        //NEW
                        if (previousTwoYearIndex == yearIndex) {
                            previousCurrentNext.twoYear = data.id
                        }
                        if (previousThreeYearIndex == yearIndex) {
                            previousCurrentNext.threeYear = data.id
                        }
                    //end NEW
                        if (previousYearIndex == yearIndex) {
                            previousCurrentNext.previous = data.id
                        }

                        if (nextYearIndex == yearIndex) {
                            previousCurrentNext.next = data.id
                        }

                    })
                    this.YearPreviousCurrentNext = previousCurrentNext;
                }

            },
            setYear(year) {
                let yearValue = this.yearList.filter(function (item) {
                    return item.value === year;
                });
                this.setYearValue = yearValue[0].id;
            },
            getColsRow() {
                let formParams = {
                    "AnuSucharuReportID": parseInt(this.$route.params.id),
                    "type": "Anusucharu",
                    companyIDs: this.logData.companyID,
                    departmentIDs: this.logData.departmentID,
                    branchIDs: this.logData.branchID,
                    depoIDs: this.logData.depoID,
                    subSectionIDs: this.logData.subSectionID,
                    isFinal:true
                }
                console.log(formParams)
                axios.post('AnusucharuReport/GetColsRows', formParams).then(response => {
                    this.rows = response.data.rows
                    this.headers = response.data.groupedColumns
                    this.totals = response.data.total;
                    this.colsHeaders = response.data.columns;
                    this.reportID = response.data.reportID;
                    this.reportTitle = response.data.reportTitle;
                    this.groupLevel = response.data.groupLevel;
                    this.subColumns = response.data.subColumns;
                    this.getYearList(response.data.year);
                    this.setYear(response.data.year);
                    this.reportType = response.data.type;
                    this.companyIDsFromServer = response.data.companyIDs;
                    this.IsShowAccumulated = response.data.isShowAccumulated;
                    this.showNextYear = response.data.showNextYear;
                })
            },
            indexWhere(array, conditionFn) {
                const item = array.find(conditionFn)
                return array.indexOf(item)
            },
            //reportLog(Details) {
            //    console.log(this.logData)
            //    this.$nextTick(() => {
            //        this.$v.$reset()
            //    })
            //    let data = {};
            //    if (Details == undefined) {
            //        data = {
            //            reportID: this.logData.reportID
            //        };
            //    } else {
            //        let branchID = 0;
            //        let companyID = 0;
            //        let departmentID = 0;
            //        let depoID = 0;
            //        if (Details.companyID != "" && Details.companyID != undefined) {
            //            companyID = parseInt(Details.companyID)
            //        }
            //        if (Details.departmentID != "" && Details.departmentID != undefined) {
            //            departmentID = parseInt(Details.departmentID)
            //        }
            //        if (Details.branchID != "" && Details.branchID != undefined) {
            //            branchID = parseInt(Details.branchID)
            //        }
            //        if (Details.depoID != "" && Details.depoID != undefined) {
            //            depoID = parseInt(Details.depoID)
            //        }
            //        data = {
            //            reportID: parseInt(this.logData.reportID),
            //            companyID: parseInt(companyID),
            //            departmentID: parseInt(departmentID),
            //            branchID: parseInt(branchID),
            //            year: Details.year,
            //            depoID: parseInt(depoID)
            //        }
            //    }

            //    axios.post("ReportSettings/GetReportLogs", data).then(response => {
            //        this.loglist.rows = response.data
            //    })
            //},
            loadCrumb() {

                if (this.role == "Company") {
                    this.logData.companyID = [];
                    this.logData.companyID.push(parseInt(this.userData.companyID))
                    this.getDdlData(this.logData.companyID, 'company')
                } else if (this.role == "Branch") {
                    this.logData.companyID = parseInt(this.userData.companyID)
                    this.getDdlData(this.logData.companyID, 'company')
                    this.logData.branchID = parseInt(this.userData.branchID)
                    this.getDdlData(this.logData.branchID, 'branch')
                } else if (this.role == "Depo") {
                    this.logData.companyID = parseInt(this.userData.companyID)
                    this.getDdlData(this.logData.companyID, 'company')
                    this.logData.branchID = parseInt(this.userData.branchID)
                    this.getDdlData(this.logData.branchID, 'branch')
                    this.logData.depoID = parseInt(this.userData.depoID)
                    this.getDdlData(this.logData.branchID, 'depo')
                }
                axios.get('ReportSettings/GetReportTypeByID/' + parseInt(this.$route.params.id)).then(response => {
                    this.searchReportType = response.data
                })
                axios.get('Company/DDLCompanyList').then(response => {
                    this.listDDLData.companyList = response.data
                })
                axios.get('ReportSettings/MultipleSelectSubSectionList').then(response => {
                    this.listDDLData.subSectionList = response.data
                })

               
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadCrumb();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadCrumb();
            },
            onColumnFilter(params) {
                this.updateParams(params);
                this.loadCrumb();
            },
            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params[0].type,
                        field: params[0].field,
                    }],
                });
                this.loadCrumb();
            },
            getDdlData(data, val) {
                let formVal = {}
                if (val == "company") {
                    this.listDDLData.branchList = []
                    this.listDDLData.depoList = []
                    this.listDDLData.departmentCompanyList = []
                    this.listDDLData.departmentBranchList = []
                    this.listDDLData.departmentDepoList = []
                    this.logData.branchID = null
                    this.logData.depoID = null
                    this.logData.departmentID = null
                    formVal = {
                        companyIDs: this.logData.companyID
                    }
                    axios.post("Branch/DDLMultiSelectBranchList", formVal).then(response => {
                        this.listDDLData.branchList = response.data
                    })

                    axios.post('Company/DDLMultiSelectDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentCompanyList = response.data
                        console.log(this.listDDLData.departmentCompanyList)
                    })

                } else if (val == "branch") {
                    this.listDDLData.depoList = []
                    this.listDDLData.departmentBranchList = []
                    this.listDDLData.departmentDepoList = []
                    this.logData.depoID = null
                    this.logData.departmentID = null

                    formVal = {
                        BranchIDs: this.logData.branchID
                    }
                    axios.post("Depo/DDLMultiSelectDepoList", formVal).then(response => {
                        this.listDDLData.depoList = response.data
                    })

                    axios.post('Branch/DDLMultiSelectDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentBranchList = response.data
                    })


                } else if (val == "depo") {
                    this.listDDLData.departmentDepoList = []
                    this.logData.departmentID = null

                    formVal = {
                        DepoIDs: this.logData.depoID
                    }
                    axios.post('Depo/DDLMultiSelectDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentDepoList = response.data
                    })
                }

            },
            reset() {
                this.logData = {
                    companyID: null,
                    departmentID: null,
                    branchID: null,
                    depoID: null
                }
                this.getColsRow();
            },
            search() {
                this.getColsRow();
            }

        }
    };
</script>

<style lang="scss" scoped>

    .v-sheet--offset {
        top: -24px;
        position: relative;
    }

    .tbl th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: $main-color;
        color: white;
    }

    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        padding: 15px;
    }

    .tfoot {
        background-color: #d2d2d2;
    }

    #form_card {
        text-align: center;
    }

    .box-border {
        border: 1px solid;
        padding: 1em;
    }

    .employee-form-header {
        background-color: $main-color;
        height: 3em;
        padding: .6em;

        span {
            color: #ffffff;
            font-size: 1.4em;
        }

    }

    .form-company {
        margin-bottom: 4em;
    }

    .tbl-btn {
        text-align: right;
        padding: 1em;
    }

    .sticky-table-header {
        thead {
            position: sticky;
            top: 160px;
            z-index: 1;
        }
    }
</style>
